module.exports = __webpack_public_path__ + "static/media/air-cargo-freight-azur-carrying-personal-protection-equipment.2d26687a.jpeg";